import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterArticle_template} from "./filterArticle_template";
import {
    filterSingleDate_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {pollQuestion_template} from "./pollQuestion_template";
import {UuidGenerator} from "../../utils/UuidGenerator";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {PollEditMarkupIds, PollMarkup} from "./pollMarkup";
import {PollCommercialSignals} from "../../utils/PollCommercialSignals";

declare var ko: any;

export class pollsEdit_template extends vnTemplate{

    public static readonly MARKUP_IDS: PollEditMarkupIds = {
        sectionLabelInput: "poll_section_label",
        addSectionButton: "add_section",
        addQuestionButton: "add_new_question_btn",
    };

    protected datePicker: filterSingleDate_template;
    protected brandsFilter : multipleSelector_template;
    protected pollQuestionLightbox: pollQuestion_template;
    protected uuidGenerator: UuidGenerator;
    protected referenceArticle: filterArticle_template;
    protected discussionArticle: filterArticle_template;

    protected getTemplateHtml(): string{
        return `
            <div class="w-form w-form-large form-poll">
                <div class="form-header">
                    <input id="poll-id" data-bind="value: id" type="hidden">
                    <h3 class="form-title icon i-poll" data-bind="text: id() != null ? 'Edit Poll' : 'Add Poll'"></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>
    
                ${ PollMarkup.sectionHeading('Info') }

                ${ PollMarkup.editInfoPanel({
                    titleInputId: 'title',
                    datePickerContainerId: 'datePicker',
                    datePickerLabelFor: 'singleDatePicker',
                    brandTagsContainerId: 'selected-brands',
                    selectedArticleContainerId: 'poll-selected-source-article',
                    selectedDiscussionArticleContainerId: 'poll-selected-discussion-article',
                    datePickerHtml: this.datePicker.getHtmlBuild(),
                    brandsFilterHtml: this.brandsFilter.getHtmlBuild(),
                    referenceArticleHtml: this.referenceArticle.getHtmlBuild(),
                    discussionArticleHtml: this.discussionArticle.getHtmlBuild(),
                }) }
                ${ PollMarkup.sectionHeading('Content', ';padding-top: 1rem') }
                <div class="w-poll-body">
                    ${ PollMarkup.editSectionsAndToolbar(pollsEdit_template.MARKUP_IDS) }
                    ${ PollMarkup.questionEditCards() }
                </div>
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>

            ${ PollMarkup.questionLightbox(this.pollQuestionLightbox.getHtmlBuild()) }
            `;
    }


    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    protected initPartial(): void {

        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.datePicker.toggleClearButton(true);
        this.datePicker.setMinutesInterval(1);
        // A poll only closes on a date somebody chose, so the picker drops the current date it starts with.
        this.setDateClosed(null);

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("Brands");
        this.brandsFilter.setFilterContainerClass('margin-neg');
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('');

        this.pollQuestionLightbox = new pollQuestion_template("pollQuestionLightbox", this.getTemplateViewModel(), this.caller);
        this.pollQuestionLightbox.setHideHeaderTitle(true);

        this.uuidGenerator = new UuidGenerator();
        this.referenceArticle = new filterArticle_template('referenceArticle', this.getTemplateViewModel(), this.caller);
        this.referenceArticle.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.referenceArticle.setShowDetails(true);
        this.referenceArticle.setShowSelectedArticlesDetails(true);
        this.referenceArticle.setTagContainerId('poll-selected-source-article');
        this.referenceArticle.setIsLoadingAnimationEnable(true);

        this.discussionArticle = new filterArticle_template('discussionArticle', this.getTemplateViewModel(), this.caller);
        this.discussionArticle.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.discussionArticle.setShowDetails(true);
        this.discussionArticle.setShowSelectedArticlesDetails(true);
        this.discussionArticle.setTagContainerId('poll-selected-discussion-article');
        this.discussionArticle.setIsLoadingAnimationEnable(true);
    }

    /**
     * Building the calendar writes the current date into the field, so the close date is put back the
     * way it was: empty until someone picks one, the poll's own date when it already has one.
     */
    public buildDatePickerCalendar() {

        const dateClosed = this.getDateClosed();
        this.datePicker.buildCalendar();
        this.setDateClosed(dateClosed);
    }

    protected getTemplateName(): string{
        return "pollsEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let self = this;
        let vm: any = {
            id: ko.observable(null),
            brandId: ko.observable(null),
            discussionArticleBrandName: ko.observable(""),
            name: ko.observable(""),
            description: ko.observable(""),
            idReferenceArticle: ko.observable(),
            idReferenceBrand: ko.observable(null),
            dateGeneratedFromArticle: ko.observable(null),
            sections: ko.observableArray([]),
            questions: ko.observableArray([]),
            signalTypes: ko.observableArray([]),
            dateClosed: ko.observable(null),
            pollSectionLabel: ko.observable(""),
            pollSectionId: ko.observable(null),
            isQuestionLightBoxShown: ko.observable(false),
            isGeneratingCommercialSignals: ko.observable(false),
            questionOperationTitle: ko.observable("Add Question"),
            onClickCancel:  (data, event) => { self.onClickCancel(data); },
            onClickSave:  (data, event) => { self.onClickSave(); },
            onClickGenerateCommercialSignals: (data, event) => { self.onClickGenerateCommercialSignals(); },
            onClickModifyDatePicker:  (data, event) => { self.clearDateClosed(data);},
            onClickAddPollSection:  (data, event) => { self.onClickAddpollSections(); },
            onClickDeletePollSection:  (data, event) => { self.onClickDeletePollSection(data); },
            onClickEditPollQuestion: (data, evt) => { self.onClickEditPollQuestion(data); },
            onClickDeletePollQuestion: (data, evt) => { self.onClickDeletePollQuestion(data); },
            onCloseEditedPollQuestion: (data, evt) => { self.onCloseEditedPollQuestion(data); },
            onClickAddPollQuestion: (data, evt) => { self.onClickAddPollQuestion(data); },
            onClickToggleQuestionCommercial: (data) => { self.onClickToggleQuestionCommercial(data); },
            onClickToggleAllQuestionsCommercial: () => { self.onClickToggleAllQuestionsCommercial(); },
            getQuestionCommercialToggleLabel: (question) => { return self.getQuestionCommercialToggleLabel(question); },
            hasCommercialSignals: (question) => { return self.hasCommercialSignals(question); },
            formatCommercialSignal: (choice) => { return self.formatCommercialSignal(choice); },
            getCommercialSignalParts: (choice) => { return self.getCommercialSignalParts(choice); },
            onClickGenerateBasedOnArticle: () => { self.caller.generateBasedOnArticle(); },
            handleDragAndDrop: (element, currentObservableArray, childrenSelector) => {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
        };
        vm.hasReferenceArticle = ko.pureComputed(() => self.hasArticleSelection(vm.referenceArticle));
        vm.hasDiscussionArticle = ko.pureComputed(() => self.hasArticleSelection(vm.discussionArticle));
        // Enabled only when at least one complete question (has text + at least one response) exists.
        vm.canGenerateCommercialSignals = ko.computed(() => PollCommercialSignals.canGenerate(vm.questions()));

        vm.hasAnyCommercialSignals = ko.pureComputed(() => PollCommercialSignals.hasAny(vm.questions(), self.getSignalTypes()));

        vm.commercialToggleLabel = ko.pureComputed(() => PollCommercialSignals.getToggleAllLabel(vm.questions(), self.getSignalTypes()));

        return vm;
    }

    public getViewModelForRequest(){

        return {
            id: this.getId(),
            name: this.getName(),
            questions: this.getQuestions(),
            dateClosed: this.getDateClosed(),
            brands: this.brandsFilter.getSelectedItems(),
            idReferenceArticle: this.getReferenceArticleId(),
            idReferenceBrand: this.getReferenceBrandId(),
            dateGeneratedFromArticle: this.getTemplateViewModel().dateGeneratedFromArticle(),
            discussionArticle: this.getDiscussionArticleForRequest(),
        };
    }

    protected hasArticleSelection(articleViewModel): boolean {
        if (!articleViewModel) {
            return false;
        }

        const selectedArticles = articleViewModel.articleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return true;
        }

        const articleObj = articleViewModel.articleObj();
        if (articleObj && articleObj.id) {
            return true;
        }

        return !!articleViewModel.idArticle();
    }

    /**
     * The editor only ever shows the brand it was opened on, so it submits that brand alone: the
     * discussion articles of the other brands attached to the poll are left as they are.
     */
    public getDiscussionArticleForRequest(): any {
        const brandId = this.getBrandId();
        if (!brandId) {
            return null;
        }

        return {idBrand: Number(brandId), idArticle: this.getDiscussionArticleId() || null};
    }

    public setDiscussionArticleOptions(articles) { this.discussionArticle.setOptions(articles); }

    /**
     * @param discussionArticle {idBrand, idArticle, title} of the brand in context, null when it has none
     */
    public setDiscussionArticle(discussionArticle) {
        this.discussionArticle.resetArticleContainer();
        this.discussionArticle.setSelectedArticle();

        if (!discussionArticle) {
            return;
        }

        const article = {id: discussionArticle.idArticle, title: discussionArticle.title};
        this.discussionArticle.setArticles(article);
        this.discussionArticle.getTemplateViewModel().idArticle(article.id);
    }

    public getDiscussionArticleId() {
        const articleObj = this.discussionArticle.getArticleObj();
        if (articleObj && articleObj.id) {
            return articleObj.id;
        }

        const selectedArticles = this.discussionArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return selectedArticles[0].id;
        }

        return this.discussionArticle.getTemplateViewModel().idArticle();
    }

    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public setArticleOptions(articles) { this.referenceArticle.setOptions(articles); }
    public setReferenceArticle(article) {
        if (article && article.id) {
            this.referenceArticle.resetArticleContainer();
            this.referenceArticle.setArticles(this.formatReferenceArticleForDisplay(article));
            this.referenceArticle.getTemplateViewModel().idArticle(article.id);
            return;
        }

        const idReferenceArticle = this.getTemplateViewModel().idReferenceArticle();
        if (idReferenceArticle) {
            this.referenceArticle.resetArticleContainer();
            this.referenceArticle.setArticles(this.formatReferenceArticleForDisplay({
                id: idReferenceArticle,
                title: `Article #${idReferenceArticle}`,
            }));
            this.referenceArticle.getTemplateViewModel().idArticle(idReferenceArticle);
        } else {
            this.referenceArticle.resetArticleContainer();
        }
    }
    public getReferenceArticleId() {
        const articleObj = this.referenceArticle.getArticleObj();
        if (articleObj && articleObj.id) {
            return articleObj.id;
        }

        const selectedArticles = this.referenceArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return selectedArticles[0].id;
        }

        return this.referenceArticle.getTemplateViewModel().idArticle();
    }

    protected formatReferenceArticleForDisplay(article): any {
        if (!article) {
            return article;
        }

        const title = article.title || '';
        const id = article.id || '';
        const brandName = article.brandName || article.brandShortName || article.brand || article.shortName
            || this.getReferenceBrandName();

        return {
            ...article,
            title: `${title} (${id} - ${brandName})`,
        };
    }

    protected getReferenceBrandName(): string {
        const referenceBrandId = this.getReferenceBrandId();
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => {
            return Number(brandReference.id) === Number(referenceBrandId);
        });

        return brand ? (brand.name || brand.shortName || '') : '';
    }
    public getReferenceBrandId() { return this.getTemplateViewModel().idReferenceBrand() || this.getBrandId(); }
    public setReferenceBrandId(idReferenceBrand) { this.getTemplateViewModel().idReferenceBrand(idReferenceBrand || this.getBrandId()); }
    public lockReferenceArticle(dateGeneratedFromArticle: string) {
        this.getTemplateViewModel().dateGeneratedFromArticle(dateGeneratedFromArticle || new Date().toISOString().slice(0, 19).replace('T', ' '));
        this.referenceArticle.setDisableField(true);
    }
    public setDateGeneratedFromArticle(dateGeneratedFromArticle: string | null) {
        this.getTemplateViewModel().dateGeneratedFromArticle(dateGeneratedFromArticle || null);
        this.referenceArticle.setDisableField(!!dateGeneratedFromArticle);
    }
    public setGeneratedQuestions(questions: any[]) {
        this.setQuestions((questions || []).map((q: any) => ({
            id: this.uuidGenerator.uuid(),
            type: q.type || (q.selection_type === 'multi_select' ? 'multi-select' : 'single-select'),
            question: q.question,
            choices: (q.choices || q.responses || []).map((choice: any, choiceIndex: number) => {
                const choiceText = typeof choice === 'string' ? choice : (choice.choiceText || choice.choiceLabel || '');
                return {
                    uuid: this.uuidGenerator.uuid(),
                    id: choiceIndex + 1,
                    choiceLabel: choiceText,
                    choiceText,
                    votes: 0,
                    commercialSignal: typeof choice === 'string' ? '' : (choice.commercialSignal || ''),
                    commercialEntity: typeof choice === 'string' ? '' : (choice.commercialEntity || ''),
                    commercialValue: typeof choice === 'string' ? '' : (choice.commercialValue || ''),
                };
            }),
            sectionId: 0,
            section: 'Unassigned',
            votes: 0,
        })));
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public hasId() {

        let id = this.getId();

        return !!id;
    }


    public getName() {
        return this.getTemplateViewModel().name();
    }

    public onClickSave(){
        this.caller.savePoll();
    }

    public onClickGenerateCommercialSignals(){
        this.caller.generateCommercialSignals();
    }

    public setIsGeneratingCommercialSignals(isGenerating) {
        this.getTemplateViewModel().isGeneratingCommercialSignals(isGenerating);
    }

    public getIsGeneratingCommercialSignals() {
        return this.getTemplateViewModel().isGeneratingCommercialSignals();
    }

    public getSignalTypes() {
        return this.getTemplateViewModel().signalTypes();
    }

    public setSignalTypes(signalTypes) {
        this.getTemplateViewModel().signalTypes(signalTypes || []);
        this.pollQuestionLightbox.setSignalTypes(signalTypes || []);
    }


    public onClickCancel(data){
        let brandId = this.getBrandId();
        let pollId = this.getId();
        this.caller.cancel(pollId, brandId);
    }

    public onClickAddpollSections() {


        let section = {
            id: this.uuidGenerator.uuid(),
            position: this.getNextSectionPosition(),
            name: this.getPollSectionLabel(),
            canDelete: true,
            length: 0
        };

        this.addSection(section);
        this.setPollSectionLabel('');
    }

    public onClickDeletePollSection(data) {
        let sections = this.getSections();
        sections = sections.filter(section => section.id !== data.id);
        this.setSections(sections);
    }

    public onClickEditPollQuestion(data) {

        this.pollQuestionLightbox.reset();
        this.pollQuestionLightbox.asEdit();
        let questionCopy = ko.toJS(data);
        this.pollQuestionLightbox.setPollQuestion(questionCopy);

        this.setQuestionOperationTitle('Update Question');

        let sections = this.getSections();
        this.pollQuestionLightbox.setPollSections(sections);
        this.setIsQuestionLightBoxShown(true);
    }

    public onClickDeletePollQuestion(question) {
        this.removeQuestion(question);
    }


    public onCloseEditedPollQuestion(data) {
        this.cancelEditedQuestionInList(data);
    }

    public setBrandId(brandId) {
        this.getTemplateViewModel().brandId(brandId);
        this.refreshDiscussionArticleBrandName();
    }

    protected refreshDiscussionArticleBrandName(): void {
        const brandId = Number(this.getBrandId());
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => Number(brandReference.id) === brandId);

        this.getTemplateViewModel().discussionArticleBrandName(brand ? (brand.name || brand.shortName || "") : "");
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public onClickAddPollQuestion(data) {

        this.pollQuestionLightbox.asAdd();
        let sections = this.getSections();
        this.pollQuestionLightbox.setPollSections(sections);
        this.setQuestionOperationTitle('Add Question');
        this.setIsQuestionLightBoxShown(true);
    }

    public setPollSectionLabel(label){
        this.getTemplateViewModel().pollSectionLabel(label);
    }

    public getPollSectionLabel(){
        return this.getTemplateViewModel().pollSectionLabel();
    }

    public setIsQuestionLightBoxShown(isQuestionLightBoxShown) {
        this.getTemplateViewModel().isQuestionLightBoxShown(isQuestionLightBoxShown);
    }


    public getIsQuestionLightBoxShown() {
        return this.getTemplateViewModel().isQuestionLightBoxShown();
    }

    public getQuestions() {
        return this.getTemplateViewModel().questions();
    }

    public hasQuestions(): boolean {
        return this.getQuestions().length > 0;
    }

    public setQuestions(questions) {
        this.getTemplateViewModel().questions(this.normalizeQuestions(questions));
    }

    private normalizeQuestions(questions) {
        return PollCommercialSignals.normalizeQuestions(questions, this.getSignalTypes());
    }

    protected hasCommercialSignals(question) {
        return PollCommercialSignals.hasSignals(question, this.getSignalTypes());
    }

    protected onClickToggleQuestionCommercial(question) {
        PollCommercialSignals.toggle(question, this.getSignalTypes());
    }

    protected onClickToggleAllQuestionsCommercial() {
        PollCommercialSignals.toggleAll(this.getQuestions(), this.getSignalTypes());
    }

    protected getQuestionCommercialToggleLabel(question) {
        return PollCommercialSignals.getToggleLabel(question, this.getSignalTypes());
    }

    protected getCommercialSignalParts(choice) {
        return PollCommercialSignals.getParts(choice, this.getSignalTypes());
    }

    protected formatCommercialSignal(choice) {
        return PollCommercialSignals.format(choice, this.getSignalTypes());
    }

    public addQuestion(question) {
        let questions = this.getQuestions();
        questions.push(question);
        this.setQuestions(questions);
    }

    public updateEditedQuestionInList(question) {

        let questions = this.getQuestions();

        let updatedQuestions = [];
        questions.forEach((q) => {
            if (q.id === question.id) {
                updatedQuestions.push(question);
            } else {
                updatedQuestions.push(q);
            }
        });

        this.setQuestions(updatedQuestions);
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public cancelEditedQuestionInList(question) {
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public removeQuestion(question) {
        let questions = this.getQuestions();
        let filteredQuestions = questions.filter((q) => q.id !== question.id);
        this.setQuestions(filteredQuestions);
        this.decrementSectionCounts(question);
    }

    public addQuestionToList(question) {
        this.addQuestion(question);
        this.incrementSectionCounts(question);
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public incrementSectionCounts(question) {
        let sections = this.getSections();

        sections.forEach((s) => {
            if (s.id === question.sectionId) {
                s.length = s.length + 1;
            }
        });

        this.setSections(sections);
    }

    public decrementSectionCounts(question) {

        let sections = this.getSections();
        sections.forEach((s) => {
            if (s.id === question.sectionId) {
                s.length = s.length - 1;
            }
        });

        this.setSections(sections);
    }

    public setSections(sections) {

        let cleanedSections = sections.filter((s) => s.id !== 0);

        this.getTemplateViewModel().sections([]);
        this.getTemplateViewModel().sections(cleanedSections);
        this.pollQuestionLightbox.setPollSections(cleanedSections);
    }

    public setAttachedBrands(brandResults) {

        if (!this.hasId()) {
            this.setAutomaticCurrentBrand();
            return;
        }

        let brandIds = [];
        brandResults.forEach((br) => {
            if (br.isActive) {
                brandIds.push(br.idBrand);
            }
        });
        this.brandsFilter.setSeletedItemIds(brandIds, true);
    }

    public setAutomaticCurrentBrand() {

        let id = this.getId();
        if (!id) {

            let brandId = this.getBrandId();
            let brandIds = [Number(brandId)];
            this.brandsFilter.setSeletedItemIds(brandIds, true);
        }
    }

    public getSections() {
        return this.getTemplateViewModel().sections();
    }

    public getNextSectionPosition() {
        let sections = this.getSections();

        return sections.length + 1;
    }

    public addSection(section) {
        let sections = this.getSections();
        sections.push(section);
        this.setSections(sections);
    }

    public setName(name){
        this.getTemplateViewModel().name(name);
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description);
    }

    public getDescription(){
        return this.getTemplateViewModel().description();
    }

    public setDateClosed(dateClosed){

        this.datePicker.setDate(dateClosed || null);
    }

    public getDateClosed(){

        return this.getTemplateViewModel().filterDate.singleDatePicker();
    }

    public clearDateClosed(data){
        //If set to Active (true) clear close date
        if (data) {
            this.datePicker.setDate(null);
        }
    }

    public setQuestionOperationTitle(questionOperationTitle) {
        this.getTemplateViewModel().questionOperationTitle(questionOperationTitle);
    }

    public getQuestionOperationTitle() {
        return this.getTemplateViewModel().questionOperationTitle();
    }

    public setReferences(references) {

        this.setBrandsReferences(references.brands);
        this.setSignalTypes(references.signalTypes);
    }
    public setBrandsReferences(brands) {

        let brandsRefs = [];
        brands.forEach((b) => {
            brandsRefs.push({
                id: b.id,
                name: b.name
            });
        });

        this.brandsFilter.setItems(brands);
        this.refreshDiscussionArticleBrandName();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollsEdit_template.ts